import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  icon: {
    fontSize: UNIT * 1.5,
    color: mainColor.colorBlack
  },
  removeIcon: { width: UNIT, height: UNIT },
  checked: {},
  autocomplete: { width: '100%' },
  label: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 0,
    bottom: 0
  },
  shrink: {
    right: 'unset'
  },
  listOptions: {
    maxHeight: UNIT * 8.75,
    marginTop: UNIT * 0.625,
    paddingLeft: UNIT * 0.625,
    borderRadius: UNIT,
    overflow: 'auto',
    border: '1px gray solid',
    position: 'relative'
  },
  checkboxList: {
    display: 'flex',
    cursor: 'pointer',
    margin: -UNIT * 0.1875,
    marginRight: 0
  },
  modalStyle: {
    padding: UNIT * 1.25
  },
  disabled: {
    pointerEvents: 'none',
    opacity: 0.6
  }
});
